export default {
  'en-US': {
    additionalPricingCharges: {
      signatureRequired: 'Signature Required Charges',
      additionalHandling: 'Additional Handling Charges',
      insurance: 'Additional Insurance Charges',
      covidCarrierSurcharge: 'COVID Surcharge',
      mailInnovationsOptOut: 'Opting out of UPSMI',
      holidaySurcharge: 'Holiday Surcharge',
      peakSurcharge: 'Peak Surcharge',
      nonMachinableHandling: 'Non-Machinable Handling',
      dimensionsNonStandardNonComplianceSurcharge: 'Dimensions NonStandard Noncompliance Charges',
      fuelSurcharge: 'Fuel Surcharge'
    }
  }
}

